import { render, staticRenderFns } from "./UsersDataTable.vue?vue&type=template&id=e12653ee&scoped=true"
import script from "./UsersDataTable.vue?vue&type=script&lang=js"
export * from "./UsersDataTable.vue?vue&type=script&lang=js"
import style0 from "./UsersDataTable.vue?vue&type=style&index=0&id=e12653ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e12653ee",
  null
  
)

export default component.exports